module.exports = require("./src/vue-select.js");


/*****************
 ** WEBPACK FOOTER
 ** vue-select (bower component)
 ** module id = 6
 ** module chunks = 0
 **/